{
  "app": {
    "name": "Hey Life",
    "tagline": "Your week with God, one small step at a time."
  },
  "tabs": {
    "home": "Home",
    "grow": "Grow",
    "challenges": "Challenges",
    "community": "Community",
    "me": "Me"
  },
  "common": {
    "continue": "Continue",
    "next": "Next",
    "back": "Back",
    "save": "Save",
    "cancel": "Cancel",
    "send": "Send",
    "share": "Share",
    "done": "Done",
    "close": "Close",
    "later": "Later",
    "yes": "Yes",
    "notYet": "Not yet",
    "notInterested": "Not interested",
    "loading": "Loading…",
    "retry": "Try again",
    "offline": "You are offline. Showing the last loaded content.",
    "points": "{count, plural, one {# point} other {# points}}",
    "days": "{count, plural, one {# day} other {# days}}",
    "dayOf": "Day {day} of {total}",
    "sessionOf": "Session {n} of {total}",
    "error": "Something went wrong.",
    "optional": "optional",
    "today": "Today",
    "watch": "Watch",
    "copy": "Copy",
    "justNow": "just now",
    "report": "Report",
    "block": "Block user",
    "offlinePending": "{n} waiting to sync"
  },
  "onboarding": {
    "welcomeTitle": "Hey. Good that you are here.",
    "welcomeBody": "Daily word, prayer, challenges and your community — all in one place.",
    "start": "Get started",
    "whereTitle": "Where are you starting from?",
    "guest": "Just look around",
    "guestHint": "No account. Your data stays on this device.",
    "account": "Create an account",
    "accountHint": "Email only. Journal, credentials and points stay with you — even on a new device.",
    "signInApple": "Continue with Apple",
    "signInGoogle": "Continue with Google",
    "signInEmail": "Continue with email",
    "emailLabel": "Email",
    "nameLabel": "Full name",
    "aliasLabel": "What should we call you?",
    "magicSent": "Check your inbox",
    "magicSentBody": "We sent a sign-in link to {email}. Open it on this device.",
    "churchTitle": "Your church",
    "churchBody": "Pick your church to see its content, Fams and prayer wall.",
    "churchOther": "Another church",
    "churchOtherLabel": "Name of your church",
    "churchNone": "I do not belong to a church",
    "langTitle": "Language",
    "langHint": "You can change this later.",
    "aliasTitle": "What should we call you?",
    "aliasBody": "Your name in Fams, challenges and on the prayer wall.",
    "finish": "Done",
    "skip": "Skip",
    "firstStepsKicker": "TWO FIRST STEPS",
    "firstStepsTitle": "Where do you want to start?",
    "firstStepsBody": "Pick one. You can always come back to the others.",
    "firstStepShotKicker": "3 MINUTES",
    "firstStepShot": "Watch a Hey Shot",
    "firstStepChallengeKicker": "WITH OTHERS",
    "firstStepChallenge": "Pick a challenge",
    "firstStepAskKicker": "ANONYMOUS",
    "firstStepAsk": "Ask a question"
  },
  "guest": {
    "lockedTitle": "Save this with an account",
    "lockedBody": "Journal, credentials and points stay with you — even on a new device. Email only.",
    "upgrade": "Create an account",
    "keepLooking": "Keep looking around",
    "localOnly": "Stored on this device only",
    "dataLoss": "Without an account, what you do here stays on this phone only. If you delete the app or switch devices, it is gone."
  },
  "home": {
    "dailyWordKicker": "DAILY WORD",
    "startPrayer": "Start prayer · 1 min",
    "celebrationKicker": "LATEST CELEBRATION",
    "activeQuest": "Your quest",
    "checkInToday": "Check in today",
    "nextWave": "Next wave",
    "nextWaveBody": "A new challenge starts {date}. Join and bring someone.",
    "balanceRing": "Balance",
    "balanceLocked": "Your balance ring unlocks with an account.",
    "oneThing": "One thing today",
    "oneThingDone": "Done for today",
    "season": "Season · week {week} of {weeks}",
    "watchCelebration": "Watch the Celebration",
    "oneThingHint": "Tap when you have done it.",
    "questProgress": "{n} check-ins",
    "openQuest": "Open quest",
    "seasonKicker": "SEASON",
    "readMore": "Read more",
    "goodMorning": "Good morning",
    "goodDay": "Hey",
    "goodEvening": "Good evening",
    "nudgeContinue": "Continue",
    "nudgeNotInterested": "Not interested",
    "nudgeSession": "Session {x} of {y} · {n} questions · 1 reflection",
    "nudgeKicker": "GROW · QUESTIONS OPEN",
    "nudgeBody": "You watched the video but the questions are still open. Finish it in two minutes.",
    "balanceHint": "Your last 7 days across body, mind, heart and spirit.",
    "balanceA11y": "Balance ring, {percent} percent of your weekly rhythm",
    "ring": {
      "body": "Body",
      "mind": "Mind",
      "heart": "Heart",
      "spirit": "Spirit"
    }
  },
  "prayer": {
    "ofTheDay": "Prayer of the Day",
    "iPrayed": "I prayed",
    "prayedCount": "{count, plural, =0 {Nobody has prayed yet} one {# person prayed} other {# people prayed}}",
    "shareCard": "Share prayer card",
    "sendToFam": "Send to my Hey Fam",
    "wall": "Prayer wall",
    "newRequest": "New request",
    "anonymous": "Post anonymously",
    "urgent": "Urgent",
    "visibleIn": "Visible in {where}",
    "visibleFam": "your Hey Fam",
    "visibleChurch": "your church",
    "visibleAll": "the whole Hey Life community",
    "answered": "Answered",
    "markAnswered": "Mark as answered",
    "withdraw": "Withdraw",
    "dailyLimit": "You can post up to 3 requests a day.",
    "start": "Pray",
    "prayedToday": "Prayed today",
    "cardReady": "Your prayer card",
    "cardBody": "Share the prayer with someone who needs it today.",
    "forSomeone": "Pray for someone",
    "amenPoints": "+{n} points for praying",
    "shared": "Shared · +{n} points",
    "minute": "{n} min",
    "open": "Open",
    "answeredFilter": "Answered",
    "mine": "Mine",
    "composerPlaceholder": "What can we pray for?",
    "category": "Category",
    "post": "Share request",
    "posted": "Shared. {points} points.",
    "cat": {
      "health": "Health",
      "family": "Family",
      "work": "Work",
      "faith": "Faith",
      "relationships": "Relationships",
      "finances": "Finances",
      "other": "Other"
    },
    "anonymousLabel": "Anonymous",
    "urgentLabel": "Urgent",
    "nowVisible": "Visible in {where} now",
    "escalatesAt": "Goes to the whole church at {time} if nobody prays.",
    "prayedBtn": "I prayed",
    "prayedDone": "Prayed",
    "wallEmpty": "No requests here yet.",
    "answeredNote": "How was it answered? (optional)",
    "withdrawn": "Withdrawn.",
    "crisisNote": "That sounds heavy. Someone from your church will reach out. You are not alone.",
    "guestWallHint": "As a guest you see requests shared with everyone.",
    "forName": "For {name}"
  },
  "grow": {
    "paths": "Paths",
    "shots": "Hey Shots",
    "shot": "Hey Shot",
    "sessionKicker": "SESSION {n} OF {total}",
    "questionsOpen": "GROW · QUESTIONS OPEN",
    "nudgeTitle": "You watched the video. Your questions are waiting.",
    "remindNext": "Remind me next time",
    "remindMore": "Remind me · {n} more",
    "remindToast": "Okay — we will remind you next time you open the app.",
    "lastReminder": "Last reminder. After this we will not ask again.",
    "oneThought": "One thought",
    "oneThoughtTitle": "Growth does not happen by watching — it happens by reflecting.",
    "continueAfterAll": "Continue after all",
    "watchAnother": "Watch another video",
    "toReflection": "To the reflection",
    "nextQuestion": "Next question",
    "prevQuestion": "Previous question",
    "watchAgain": "Watch video again",
    "correct": "Right",
    "wrong": "Not quite",
    "whatContentSaid": "What the content said",
    "reflectionToFam": "Share to my Hey Fam",
    "reflectionToJournal": "Private to journal",
    "certificate": "Certificate",
    "askAnonymously": "Ask a question anonymously",
    "questionSent": "Sent. Someone from the team will answer in the app.",
    "startSession": "Start session",
    "continueSession": "Continue",
    "locked": "Finish the previous session first.",
    "watch": "Watch video",
    "toQuestions": "To the questions",
    "videoWatched": "Video watched",
    "stepCard": "Your step",
    "reflectionTitle": "Reflection",
    "reflectionPlaceholder": "What do you take with you?",
    "myQuestions": "My questions",
    "questionPlaceholder": "Your question for the team …",
    "answerPending": "Answer arrives in the app",
    "pathDone": "Path completed",
    "certificateEarned": "You earned a certificate",
    "shareCertificate": "Share certificate",
    "completedOf": "{done} of {total} sessions",
    "earnedPoints": "+{n} points",
    "sessionDone": "Session complete",
    "sessionDoneBody": "Strong. Your next step is waiting.",
    "noShots": "No shots yet.",
    "shotsBody": "Short impulses from your church.",
    "pathsBody": "Videos, questions, one step. Session by session.",
    "questionsLeft": "{n} questions",
    "question": "Question {n} of {total}",
    "yes": "Yes",
    "no": "No",
    "reflectionSaved": "Saved.",
    "famNeeded": "You need a Hey Fam to share there.",
    "toCertificates": "My certificates"
  },
  "challenges": {
    "title": "Challenges",
    "join": "Join",
    "invite": "Invite someone",
    "inviteBody": "Share your link. Whoever joins through it starts on your day.",
    "checkIn": "Check in",
    "checkedIn": "Checked in",
    "addPhoto": "Add a photo",
    "completeTitle": "You did it.",
    "completeBody": "{count} check-ins. One reflection question before you go.",
    "chat": "Chat",
    "chatReadOnly": "This chat is read-only now.",
    "totalOnCompletion": "{points} points on completion",
    "stayTogether": "Stay together as a Fam?",
    "report": "Report",
    "block": "Block",
    "discover": "Discover",
    "filterDuration": "Duration",
    "filterArea": "Life area",
    "all": "All",
    "noMatches": "No matches",
    "resetFilters": "Reset filters",
    "short": "up to 9 days",
    "medium": "10–20 days",
    "long": "21+ days",
    "area": {
      "spirit": "Spiritual",
      "body": "Body",
      "mind": "Mind",
      "relationships": "Relationships",
      "finances": "Finances",
      "work": "Work",
      "leisure": "Leisure"
    },
    "participants": "{count, plural, =0 {Nobody yet} one {# person} other {# people}} joined",
    "nextStart": "Next start: {date}",
    "startToday": "Starts today",
    "whatToExpect": "What to expect",
    "dailyRoutine": "Daily routine",
    "dailyRoutineBody": "One check-in a day: a sentence, a photo if you like.",
    "pointsPerDay": "{points} points per day",
    "joinToday": "Join today's wave",
    "joinOn": "Join the wave of {date}",
    "joined": "You are in.",
    "yourCohort": "Your wave",
    "openWaves": "Open waves",
    "day": "Day {day}",
    "dayOf": "Day {day} of {total}",
    "skipped": "skipped",
    "missed": "missed",
    "checkedInDay": "Done",
    "todayPrompt": "Today",
    "checkInNote": "One sentence about today (optional)",
    "checkInSaved": "Checked in. {points} points.",
    "alreadyToday": "You already checked in today.",
    "missedBody": "Missed days are fine. Just continue today.",
    "upcoming": "Starts on {date}",
    "upcomingBody": "The wave starts soon. Invite someone to start together.",
    "finished": "Finished",
    "members": "{count, plural, one {# member} other {# members}}",
    "inviteLink": "Invite link",
    "copyLink": "Copy link",
    "linkCopied": "Copied.",
    "shareLink": "Share link",
    "completionReflection": "What changed for you in these {days} days?",
    "completionJournalHint": "Your answer goes into your journal.",
    "completionGuestHint": "With an account your answer would be saved in your journal.",
    "shareCard": "Share completion card",
    "cardFiled": "Your card is filed under Me → Certificates.",
    "chatPlaceholder": "Write to your wave…",
    "chatEmpty": "Nobody has written yet. Say hi.",
    "guestName": "You post as {name}.",
    "reported": "Reported. We hid it for you.",
    "blocked": "Blocked. You will not see posts from this person anymore.",
    "reportReason": "Why are you reporting this?",
    "reportSent": "Thanks. The team will take a look.",
    "leave": "Leave challenge",
    "joinedViaInvite": "You start on day {day} — like {name}.",
    "joinedViaInviteNoName": "You start on day {day}.",
    "inviteTitle": "Invitation",
    "inviteBodyLanding": "Join the wave and start today.",
    "activeTitle": "Your challenges",
    "past": "Finished",
    "none": "No active challenge. Pick one below.",
    "checkInQueued": "Check-in saved on this phone. It syncs when you are back online."
  },
  "community": {
    "title": "Community",
    "sectionsOff": "This church has turned Community off.",
    "feed": "Feed",
    "myFam": "My Hey Fam",
    "famFinder": "Find a Hey Fam",
    "request": "Ask to join",
    "requested": "Requested",
    "requestedBody": "The leader will confirm. We will tell you.",
    "globalFam": "Hey Life Global",
    "globalFamBody": "Not near a Hey Church? Join the global Fam.",
    "full": "Full",
    "spots": "{count, plural, one {# spot left} other {# spots left}}",
    "makePrayer": "Make it a prayer request",
    "newPost": "New post",
    "lockedBody": "The community opens with an account.",
    "prayerTab": "Prayer",
    "feedSoon": "The feed opens with your Hey Fam.",
    "famSoon": "Find your Hey Fam here soon.",
    "famTab": "Hey Fam",
    "feedEmpty": "Nothing here yet. Your church, your Fam and your challenges post here.",
    "feedLockedTitle": "The feed opens with an account",
    "feedLockedBody": "Posts from your church, your Fam and your challenges — and your own.",
    "postPlaceholder": "What is on your mind?",
    "post": "Post",
    "posted": "Posted.",
    "postNoScope": "Join a church or the global Fam to post.",
    "fromChurch": "Church",
    "fromFam": "Fam",
    "fromChallenge": "Challenge",
    "deletePost": "Delete post",
    "yourFam": "Your Hey Fam",
    "openChat": "Open chat",
    "membersCount": "{count, plural, one {# member} other {# members}}",
    "leader": "Leader: {name}",
    "leave": "Leave Fam",
    "leaveConfirm": "Leave this Fam? You can request a new one any time.",
    "withdraw": "Withdraw request",
    "requestedTitle": "Requested",
    "requestedPco": "Your church confirms the request in Church Center. This usually takes a day or two — we will tell you.",
    "requestedManual": "Your church confirms the request. We will tell you.",
    "finderTitle": "Hey Fams near you",
    "finderBody": "Small groups that meet every week. Pick one and ask to join.",
    "finderEmpty": "Your church has not listed any Fams yet.",
    "pcoStale": "Showing the last known list — Planning Center is not reachable right now.",
    "openSeats": "{count, plural, =0 {Full} one {# seat left} other {# seats left}}",
    "online": "Online",
    "day": {
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday"
    },
    "requestSheetTitle": "Ask to join {fam}",
    "requestSheetBody": "Your request goes to your church. Fams are managed in Church Center — you can also sign up there directly. The card shows \"Requested\" until the church confirms.",
    "requestSheetConfirm": "Send request",
    "openChurchCenter": "Open Church Center",
    "requestSent": "Request sent.",
    "famFull": "This Fam is full right now.",
    "matchTitle": "Nothing that fits?",
    "matchBody": "Tell your church and get matched within 48 hours.",
    "matchCta": "Get matched",
    "matchArea": "Area (optional)",
    "matchDay": "Preferred day (optional)",
    "matchNote": "Anything we should know? (optional)",
    "matchSent": "Your church will get back to you within 48 hours.",
    "matchPending": "Match requested — your church will get back to you.",
    "globalJoin": "Join",
    "globalJoined": "Welcome to the global Hey Fam.",
    "globalCardBody": "One Fam for everyone without a Hey Church nearby. {count, plural, one {# member} other {# members}} from everywhere.",
    "chatTitle": "{fam} · chat",
    "chatPlaceholder": "Write to your Fam…",
    "chatEmpty": "Nobody has written yet. Say hi.",
    "notMember": "Only members can read this chat.",
    "stayTitle": "Stay together as a Fam?",
    "stayBody": "{title} is done. Many waves keep going as a Hey Fam — find one or start together.",
    "stayYes": "Find a Hey Fam",
    "stayNo": "Not now"
  },
  "me": {
    "title": "Me",
    "whatsUp": "What's up now",
    "credentials": "Credentials",
    "journal": "Journal",
    "prayFor": "Who I pray for",
    "myChurch": "My church",
    "invest": "Invest",
    "talk": "Talk to someone",
    "talkBody": "Tell us what is going on. Someone from the pastoral team will reach out.",
    "talkSent": "Someone will reach out.",
    "myTeam": "My team",
    "teamKicker": "MY TEAM · HEY CHURCH",
    "openTeamPage": "Open the team page",
    "teamHint": "The app only remembers that you tapped it.",
    "teamCheckinKicker": "CHECK-IN · 4 WEEKS LATER",
    "teamCheckinTitle": "Four weeks ago you looked at the teams. Where are you now?",
    "teamTrying": "I am trying it out",
    "teamArrived": "I have arrived in a team",
    "teamNoContact": "No contact yet",
    "teamNotInterested": "Not interested right now",
    "quickQuestion": "QUICK QUESTION",
    "whyNot": "Pity — can you help us understand why?",
    "haveTeam": "I already have a team",
    "unsure": "I am not sure which team fits me",
    "tellWhy": "Tell us why you are not interested",
    "points": "Points",
    "history": "History",
    "rewards": "Rewards",
    "nextReward": "{remaining} more to {reward}",
    "redeem": "Redeem",
    "redeemable": "Redeemable",
    "requested": "Requested · {leader} will get in touch",
    "sent": "Sent",
    "leaderboard": "Leaderboard",
    "leaderboardOptOut": "Hide me from the leaderboard",
    "account": "Account",
    "language": "Language",
    "notifications": "Notifications",
    "quietHours": "Quiet hours",
    "privacy": "Privacy",
    "imprint": "Imprint",
    "terms": "Terms",
    "legalTabApp": "App",
    "legalTabChurch": "{church}",
    "legalTabChurchFallback": "Hey Church",
    "legalEmpty": "No text for this tab yet.",
    "signOut": "Sign out",
    "deleteAccount": "Delete account",
    "deleteBody": "Your data is removed after 30 days. You can sign in again before then to cancel.",
    "followJesus": "I want to follow Jesus",
    "saidYes": "You said yes.",
    "bookTalk": "Book a conversation",
    "confirmSlot": "Confirm · {day} {time}",
    "pickSlot": "Day, time and email",
    "care": "Care",
    "pointsTotal": "{n} points collected",
    "noCertificates": "No certificates yet. Finish a Grow path.",
    "noPoints": "No points yet. Pray, learn, join in.",
    "certificatesBody": "Everything you have completed.",
    "alias": "Display name",
    "certificatesChallenge": "Challenge cards",
    "gymUnits": "{n, plural, =0 {No gym units yet} one {# gym unit} other {# gym units}}",
    "journalEntries": "{n, plural, =0 {Journal empty} one {# journal entry} other {# journal entries}}",
    "verseToday": "Verse of the day",
    "noVerse": "No verse today",
    "groupHeyChurch": "Hey Church",
    "groupGlobalPlus": "Global+",
    "groupGlobal": "Global",
    "groupGuest": "Guest",
    "certificatesCount": "{n, plural, =0 {No certificates yet} one {# certificate} other {# certificates}}",
    "guestHint": "Sign in to keep your journal, names and points across devices.",
    "signIn": "Sign in",
    "journalBody": "Private and encrypted. Only you can read it — never your church, never the Care team.",
    "journalGate": "Your journal needs an account so it stays private and encrypted.",
    "journalEmpty": "Nothing here yet. Completion reflections and your own notes land here.",
    "journalNew": "New entry",
    "journalPlaceholder": "What is on your mind today?",
    "journalSave": "Save",
    "journalExport": "Export",
    "journalDelete": "Delete entry",
    "journalDeleteConfirm": "Delete this entry for good?",
    "journalKindFree": "Note",
    "journalKindReflection": "Completion reflection",
    "journalKindPrompt": "Prompt",
    "journalExportTitle": "My Hey Life journal",
    "namesBody": "Up to three names. They show up when you pray the prayer of the day.",
    "namesAdd": "Add a name",
    "namesPlaceholder": "Name",
    "namesSince": "since {date}",
    "namesPrayNow": "Pray now",
    "namesMax": "Three names is the limit — remove one first.",
    "namesEmpty": "No names yet.",
    "namesGate": "Who you pray for stays with your account.",
    "namesRemove": "Remove",
    "fam": "Hey Fam",
    "famNone": "No Fam yet",
    "famRequested": "Requested",
    "famMember": "{name}",
    "investBody": "Your giving keeps Hey Life free for everyone and strengthens your church.",
    "investBodyHeyChurch": "Your giving carries {church} and keeps Hey Life free for everyone.",
    "investOnce": "Once",
    "investMonthly": "Monthly",
    "investGive": "Give {amount}",
    "investOther": "Other amount",
    "investThanksHeyChurch": "Thank you for investing in {church}.",
    "investThanksOther": "Thank you for investing in Hey Life.",
    "investUnavailable": "Giving is not set up yet.",
    "talkPlaceholder": "What is going on?",
    "talkContact": "How should we reach you? (optional)",
    "talkContactPlaceholder": "Phone, email or Instagram",
    "talkAnonymous": "Stay anonymous",
    "talkAnonymousHint": "Anonymous requests cannot be answered personally.",
    "talkSend": "Send",
    "talkOpen": "Sent {when} · someone will reach out",
    "talkInContact": "{alias} from the pastoral team is in contact with you.",
    "talkTeam": "Someone from the pastoral team is in contact with you.",
    "talkNoChurch": "Your request goes to the Hey Life care team.",
    "churchHeyChurch": "You belong to {church}, a Hey Church. Everything in the app is tuned to your church.",
    "churchGlobalPlus": "You belong to {church}. Hey Life is your companion — Global+.",
    "churchGlobal": "You have not chosen a church. You are in the Global group.",
    "chooseChurch": "Choose church",
    "switchChurch": "Switch church",
    "switchNeedsAdmin": "Switching church again needs your church admin.",
    "switchStaff": "Team members cannot leave their church here.",
    "settingsTitle": "Settings",
    "notifFamCohort": "Fam & challenges",
    "notifRhythm": "Daily rhythm",
    "notifProgress": "Progress",
    "notifPersonal": "Personal",
    "notifLocked": "Notifications need an account.",
    "notifBody": "Max. three Fam pushes and one rhythm push a day. Quiet hours hold everything except crisis alerts.",
    "quietFrom": "From",
    "quietTo": "To",
    "deleteConfirm": "Delete my account",
    "deleteRequested": "Deletion requested · your data is removed on {date}.",
    "deleteCancel": "Keep my account",
    "deleteGuest": "As a guest your data disappears immediately.",
    "languageDe": "Deutsch",
    "languageEn": "English",
    "appearance": "Appearance",
    "appearanceBody": "System follows your phone's light or dark setting.",
    "theme_system": "System",
    "theme_light": "Light",
    "theme_dark": "Dark",
    "sentryDevTitle": "Diagnostics",
    "sentryDevBody": "Send a test event to Sentry (non-production only).",
    "sentryTestMessage": "Test Sentry message",
    "sentryTestCrash": "Test Sentry crash",
    "sentryTestSent": "Test event sent to Sentry. Open your project’s Issues (filter environment: development) in a minute.",
    "careKicker": "CARE · {church}",
    "careBody": "Requests, urgent prayers and decisions of your church.",
    "pushPermission": "Allow notifications",
    "gym": "Hey Gym",
    "teamBody": "Get involved: the teams of {church} are on the website. The app only remembers that you looked.",
    "teamNoUrl": "Your church has not set a team link yet.",
    "teamAnswered": "Thanks — noted.",
    "teamFinished": "Check-ins done. Thank you.",
    "teamNextCheck": "Next check-in {date}",
    "teamLookedAt": "Looked at the teams {date}",
    "teamSend": "Send",
    "teamRatherNot": "Rather not",
    "rewardsBody": "Milestones from your church. Each reward can be redeemed once.",
    "rewardLocked": "{n} more points",
    "rewardRedeemed": "Redeemed",
    "rewardDateSet": "Date set · {leader} is in touch",
    "rewardResend": "Send the mail again",
    "rewardResent": "Mail sent.",
    "pickLeader": "Who would you like to meet?",
    "yourPhone": "Your phone number",
    "redeemConfirm": "Redeem {reward}",
    "redeemLeaderBody": "{leader} will get in touch to find a date.",
    "redeemBookBody": "We email the book to {email} right away.",
    "redeemPhysicalBody": "Your church prepares it and lets you know.",
    "nextRewardKicker": "NEXT REWARD",
    "allRewardsReached": "You reached every reward. Wow.",
    "leaderboardFam": "Hey Fam",
    "leaderboardChurch": "Hey Church",
    "leaderboardEmpty": "Nobody here yet.",
    "leaderboardNoFam": "Join a Hey Fam to see its leaderboard.",
    "leaderboardNoChurch": "Choose a Hey Church to see its leaderboard.",
    "leaderboardHidden": "You are hidden from the leaderboard. Others still see the list.",
    "leaderboardGuest": "Guests are not listed.",
    "you": "You",
    "rank": "#{n}",
    "decideKicker": "FOLLOW JESUS",
    "decideBody": "Saying yes to Jesus is the start of everything. We would love to talk with you about it.",
    "decideCta": "I want to follow Jesus",
    "decideThanks": "You said yes — we are so glad.",
    "letsTalk": "Let's talk",
    "letsTalkBody": "Book a slot with someone from your church, or let us call you.",
    "bookSlot": "Book a slot",
    "callMe": "Rather have someone call me",
    "callMeBody": "Confirm your number and someone will call you.",
    "phonePlaceholder": "+49 …",
    "callRequested": "Noted · someone will call you at {phone}",
    "slotBooked": "Your conversation: {date}",
    "talkHeld": "Conversation held. Thank you.",
    "noCalendly": "Booking is not set up for your church yet — ask to be called instead.",
    "baptismKicker": "BAPTISM HEY FAM",
    "baptismInvited": "You are invited to the Baptism Hey Fam.",
    "baptismQuestion": "Have you signed up yet?",
    "baptismSignedUp": "You are signed up for the Baptism Hey Fam.",
    "baptismYes": "Yes",
    "baptismNotYet": "Not yet",
    "decideGuest": "Create an account so your church can reach you.",
    "decideBodyOpen": "Someone from your church will reach out. Want to book a time now?",
    "teamQuickQuestion": "QUICK QUESTION",
    "teamWhyTitle": "Pity — can you help us understand why?",
    "teamHaveTeam": "I already have a team",
    "teamUnsure": "I am not sure which team fits me",
    "teamWhyPlaceholder": "Tell us why you are not interested",
    "decideTitle": "Follow Jesus",
    "nextRewardBody": "{n} more points to {title}",
    "allRewards": "All rewards",
    "redeemLeaderPick": "Who would you like to meet?",
    "redeemSend": "Redeem now",
    "rewardRequested": "Requested — your church will be in touch.",
    "rewardSent": "Sent",
    "pointsGuest": "Points stay on this device until you create an account.",
    "confirmationSent": "Confirmation sent to {email}",
    "leaderboardOptOutBody": "Your points still count; only your name disappears from the lists.",
    "journalQueued": "Saved on this phone. It syncs when you are back online."
  },
  "gym": {
    "title": "Hey Gym",
    "quizKicker": "HEY GYM · {step}",
    "goalTitle": "What is your goal?",
    "burnFat": "Burn fat",
    "burnFatSub": "Lose weight, get lighter",
    "buildMuscle": "Build muscle",
    "buildMuscleSub": "Get stronger",
    "stayFit": "Stay fit",
    "stayFitSub": "Mobile, enduring, in rhythm",
    "analysisTitle": "A short analysis",
    "weight": "Weight",
    "height": "Height",
    "age": "Age",
    "sex": "Sex",
    "limitations": "Surgeries, conditions, injuries",
    "privacyLine": "Only you can see this. Never your church, never the Care team.",
    "freqTitle": "How often a week?",
    "planPreview": "YOUR PLAN WILL BE",
    "planPreviewBody": "{goal} · {n}× a week · 6 weeks · {sessions} sessions",
    "createPlan": "Create plan",
    "planCreated": "Plan created · week 1 starts today",
    "yourPlan": "YOUR PLAN · WEEK {week} OF 6",
    "planSub": "{n} sessions a week · from your questionnaire · {goal}",
    "sessionsOf": "{x} of {y} sessions · certificate after week 6",
    "startSession": "Start session",
    "newPlan": "New plan",
    "certTitle": "Six weeks. Every session. You.",
    "certKicker": "CERTIFICATE · HEY GYM",
    "shareCert": "Share certificate",
    "newPlanNotice": "NEW PLAN · NOTICE",
    "progressLost": "Your current progress will be lost.",
    "pointsStay": "Points you already have stay.",
    "yesNewPlan": "Yes, start a new plan",
    "keepPlan": "Keep my plan",
    "goal_burn_fat": "Burn fat",
    "goal_build_muscle": "Build muscle",
    "goal_stay_fit": "Stay fit",
    "step": "{n} / 3",
    "sexF": "f",
    "sexM": "m",
    "sexX": "x",
    "perWeek": "{n}×",
    "todayKicker": "TODAY",
    "todaySession": "Session {n}",
    "todayDone": "Session done — see you next time.",
    "sessionDone": "+{points} points · session {x} of {y}",
    "sets": "{sets} × {reps}",
    "weekOf": "Week {w}",
    "unitsLabel": "{x} of {y} sessions",
    "certBody": "{alias} · {y} of {y} sessions · completed on {date}",
    "planPoints": "+{points}",
    "privacyShort": "Health data stays with you.",
    "noPlanYet": "No plan yet",
    "guestNote": "Your plan is saved with your account.",
    "phaseDone": "Plan completed",
    "exerciseInstructions": "How to",
    "optionalHint": "All fields are optional."
  },
  "care": {
    "today": "Today",
    "decisions": "Decisions",
    "cases": "Care",
    "takeOver": "Take over",
    "statusOpen": "Open",
    "statusInContact": "In contact",
    "statusClosed": "Closed",
    "anonymousRequest": "Anonymous request",
    "urgentRequests": "Urgent prayer requests",
    "talkRequests": "Talk requests",
    "noneToday": "Nothing is waiting right now.",
    "takenBy": "{alias} is on it",
    "takenByMe": "You are on it",
    "needsAnswer": "Needs an answer",
    "saidYes": "Said yes {when}",
    "talkBooked": "Conversation {when}",
    "contact": "Contact: {contact}",
    "noContact": "No contact given",
    "close": "Close",
    "reopen": "Reopen",
    "decisionsEmpty": "No decisions waiting.",
    "casesEmpty": "No cases.",
    "heyLifeTeam": "Hey Life care team",
    "source_talk_to_someone": "Talk to someone",
    "source_crisis_flag": "Crisis wording",
    "source_manual": "Manual",
    "filterAll": "All",
    "prayed": "{n, plural, one {# prayed} other {# prayed}}",
    "takenByOther": "Someone else already took this over."
  },
  "notifications": {
    "dailyWordTitle": "Your word for today",
    "checkInReminderTitle": "Still open: today's check-in",
    "newMessages": "{count, plural, one {# new message} other {# new messages}} in {room}",
    "prayedForYou": "{count, plural, one {# person prayed} other {# people prayed}} for your request",
    "famConfirmed": "Welcome to {fam}",
    "challengeComplete": "Challenge completed",
    "certificate": "Certificate earned",
    "rewardReached": "You reached {reward}",
    "crisisAlert": "Urgent: a message needs your attention"
  },
  "email": {
    "magicSubject": "Your sign-in link for Hey Life",
    "magicBody": "Tap the link to sign in. It is valid for 10 minutes.",
    "magicButton": "Sign in",
    "yesSubject": "You said yes",
    "bookSubject": "30 Days with God — your book",
    "deleteSubject": "Your Hey Life account will be deleted",
    "inviteSubject": "You were invited to the Hey Life Command Center · {church}",
    "footer": "Hey Kirche e.V. · Owiesenstraße 66 · 22177 Hamburg · office@heychurch.de",
    "inviteBody": "You have been invited to manage {church} in the Hey Life Command Center. Sign in with this email address; the second factor is set up on first sign-in.",
    "inviteButton": "Open the Command Center",
    "deletionTitle": "We will delete your account",
    "deletionBody": "Your Hey Life data will be removed on {date}. If you change your mind, simply sign in again before then — that cancels the deletion.",
    "yesTitle": "You said yes.",
    "yesBody": "Hey {name}, you said yes to following Jesus. That is the best decision you will ever make. Someone from your church will reach out — or book a conversation right in the app.",
    "yesFooter": "This mail is sent once, no matter how many points you have.",
    "bookTitle": "Your book: {title}",
    "bookBody": "Here is your reward: {title}. You can ask for this mail again any time in the Me tab.",
    "bookButton": "Open the book",
    "bookTalkTitle": "Let's talk about your yes",
    "bookTalkBody": "Two days ago you said yes. Pick a slot with someone from your church — or ask us to call you in the app.",
    "bookTalkButton": "Book a slot",
    "pdfSubject": "After our conversation",
    "pdfTitle": "Thank you for the conversation",
    "pdfBody": "Hey {name}, attached is what we talked about. Keep it close.",
    "digestSubject": "Your week at {church}",
    "digestTitle": "Your week in Hey Life",
    "digestIntro": "Here is what happened at {church} in the last seven days. Numbers only — open the Command Center for the details.",
    "digestWau": "Active people this week",
    "digestNewUsers": "New people",
    "digestCheckIns": "Check-ins",
    "digestPrayers": "Prayers of the Day prayed",
    "digestSessions": "Grow sessions completed",
    "digestGym": "Gym sessions",
    "digestFam": "Fam members confirmed",
    "digestPoints": "Points awarded",
    "digestOpenTitle": "Open right now",
    "digestOpenAlerts": "Needs Attention",
    "digestOpenRequests": "Prayer requests without an answer",
    "digestOpenCare": "Open care cases",
    "digestButton": "Open the Command Center",
    "digestFooter": "You receive this because you are a pastor or admin of this church. Change your role in the Command Center under People & Roles."
  },
  "web": {
    "linkInvalid": "This link is no longer valid",
    "startsOn": "Starts on {date}",
    "dayOf": "Day {day} of {total}",
    "finished": "Finished",
    "memberCount": "{count, plural, one {# person} other {# people}} joined",
    "joinInApp": "Join in the app",
    "getApp": "Open Hey Life",
    "prayerNotFound": "This prayer was not found"
  },
  "landing": {
    "title": "Your faith.",
    "titleAccent": "Every day.",
    "tagline": "Hey Life is the Hey Church app: daily word, prayer, challenges with friends, Grow paths and your Fam. For Hamburg, Berlin and everywhere.",
    "appStore": "Download on the App Store",
    "playStore": "Get it on Google Play",
    "featuresTitle": "What to expect",
    "features": {
      "home": {
        "title": "Home",
        "body": "Daily word, prayer of the day and the next Celebration at a glance."
      },
      "prayer": {
        "title": "Prayer",
        "body": "Pray for others, share requests with your Fam or the whole church."
      },
      "grow": {
        "title": "Grow",
        "body": "Paths with video, questions and reflection. Certificate at the end."
      },
      "challenges": {
        "title": "Challenges",
        "body": "Stick with it for 7 to 30 days, together with friends and chat."
      },
      "community": {
        "title": "Fam",
        "body": "Find your small group, stay in touch, celebrate together."
      },
      "gym": {
        "title": "Hey Gym",
        "body": "A six-week training plan for your body, because it belongs too."
      }
    },
    "imprint": "Imprint",
    "privacy": "Privacy",
    "adminLogin": "Command Center",
    "madeBy": "Hey Kirche e.V."
  },
  "admin": {
    "errorBoundary": {
      "title": "Something went wrong",
      "body": "The console hit an unexpected error. You can try again; we have been notified.",
      "retry": "Try again"
    },
    "login": {
      "title": "Command Center",
      "subtitle": "Sign-in for pastors and admins.",
      "email": "Email",
      "password": "Password (demo only)",
      "sendLink": "Send sign-in link",
      "sent": "Link sent. Check your inbox.",
      "apiUnreachable": "Cannot reach the API. Start it with pnpm api from the code folder (port 3000), then try again.",
      "signInPassword": "Sign in with password",
      "totpTitle": "Second factor",
      "totpBody": "Enter the 6-digit code from your authenticator app.",
      "code": "Code",
      "verify": "Verify",
      "noAccess": "Your account has no Command Center access. Active pastors and admins only.",
      "signOut": "Sign out",
      "back": "Back"
    },
    "nav": {
      "today": "Today",
      "content": "Content",
      "people": "People & Roles",
      "fams": "Fams",
      "prayer": "Prayer wall",
      "challenges": "Challenges",
      "notifications": "Notifications",
      "settings": "Settings",
      "questions": "Questions",
      "churches": "Churches",
      "moderation": "Moderation",
      "attention": "Needs Attention",
      "pulse": "Pulse",
      "rewards": "Points & rewards",
      "team": "Strengthen others",
      "decisions": "Follow Jesus",
      "audit": "Audit log"
    },
    "home": {
      "title": "Today",
      "welcome": "Hello {name}",
      "church": "Church",
      "status": "Status",
      "comingSoon": "This module arrives in the next milestone.",
      "platform": "Platform",
      "role": "Role"
    },
    "scope": {
      "label": "Scope",
      "global": "Global (all churches)",
      "church": "Church"
    },
    "common": {
      "loading": "Loading …",
      "error": "Something went wrong.",
      "save": "Save",
      "saved": "Saved.",
      "cancel": "Cancel",
      "delete": "Delete",
      "dragToReorder": "Drag to reorder",
      "confirmDelete": "Really delete?",
      "new": "New",
      "back": "Back",
      "de": "German",
      "en": "English",
      "yes": "Yes",
      "no": "No",
      "position": "Order",
      "published": "Published",
      "draft": "Draft",
      "edit": "Edit",
      "close": "Close",
      "open": "Open",
      "required": "Required"
    },
    "errors": {
      "generic": "Something went wrong. Please try again.",
      "required": "Please fill in {field}.",
      "invalid": "Please check {field}.",
      "tooLong": "{field} is too long.",
      "slug": "The short name needs at least 2 letters or numbers. It is written in lowercase, with dashes instead of spaces.",
      "email": "Enter a valid email address.",
      "url": "Enter a full link, starting with https://.",
      "fields": {
        "slug": "the short name",
        "name": "the name",
        "title": "the title",
        "title_de": "the German title",
        "title_en": "the English title",
        "description": "the description",
        "description_de": "the German description",
        "description_en": "the English description",
        "subtitle": "the subtitle",
        "subtitle_de": "the German subtitle",
        "subtitle_en": "the English subtitle",
        "dailyPrompt": "the daily prompt",
        "dailyPrompt_de": "the German daily prompt",
        "dailyPrompt_en": "the English daily prompt",
        "prompt": "the question",
        "prompt_de": "the German question",
        "prompt_en": "the English question",
        "explanation": "the explanation",
        "explanation_de": "the German explanation",
        "explanation_en": "the English explanation",
        "theme": "the colour",
        "email": "the email",
        "adminEmail": "the admin email",
        "videoId": "the YouTube link",
        "body": "the text",
        "body_de": "the German text",
        "body_en": "the English text"
      },
      "codes": {
        "forbidden": "You don't have permission to do that.",
        "not_found": "We couldn't find that.",
        "validation": "Please check the form and try again.",
        "invalid_body": "Please check the form and try again.",
        "internal": "Something went wrong. Please try again.",
        "church_required": "Choose a church first.",
        "invalid_youtube_link": "Enter a YouTube link or an 11-character video ID.",
        "url_or_id_required": "Enter a YouTube link or an 11-character video ID.",
        "reorder_mismatch": "The order changed. Refresh the page and try again.",
        "audience_required": "Choose who should receive this.",
        "pdf_size": "The PDF must be smaller than 10 MB.",
        "not_pdf": "That file is not a PDF.",
        "celebration_url_not_youtube": "The celebration link needs to be a YouTube link.",
        "invalid_theme": "Pick a colour from the list.",
        "slug_taken": "This short name is already used. Change it and save again.",
        "session_points_range": "Points per session must be a whole number from 0 to 1000.",
        "certificate_points_range": "Certificate points must be a whole number from 0 to 5000.",
        "position_taken": "That order number is already used. Pick another one.",
        "options_required": "Add at least two answers, one per line.",
        "correct_index_out_of_range": "The correct answer number is higher than the number of answers.",
        "invalid_question_id": "That question could not be found.",
        "invalid_answer": "That answer is not one of the choices.",
        "totp_unavailable": "The authenticator setup did not start. Try again."
      }
    },
    "today": {
      "week": "Last 7 days",
      "prayed": "Prayed",
      "sessions": "Sessions completed",
      "checkIns": "Challenge check-ins",
      "activeUsers": "Active people",
      "openQuestions": "Open questions",
      "overdue": "{n} overdue (> 48 h)",
      "scheduled": "Scheduled content (next 3 weeks)",
      "dailyWords": "Daily Words",
      "dailyPrayers": "Prayers of the Day",
      "oneThings": "One thing today",
      "members": "Members",
      "days": "{n} days",
      "toQuestions": "Go to questions",
      "toContent": "Plan content",
      "attention": "Needs attention",
      "attentionBody": "{count, plural, =0 {Nothing open} one {# open item} other {# open items}}, {overdue} overdue",
      "toAttention": "Open the queue",
      "reports": "Open reports",
      "urgent": "Urgent requests",
      "toPulse": "Pulse",
      "toFams": "Fams",
      "famRequests": "Fam requests",
      "tasks": "Tasks",
      "rewardRequests": "{n, plural, one {# reward request} other {# reward requests}}",
      "callTasks": "{n, plural, one {# personal call} other {# personal calls}}",
      "approvals": "{n, plural, one {# role approval} other {# role approvals}}",
      "teamFollowUps": "{n, plural, one {# team follow-up} other {# team follow-ups}}",
      "openDecisions": "{n, plural, one {# decision awaiting contact} other {# decisions awaiting contact}}",
      "sentToday": "Sent today",
      "sentTodayBody": "{n} messages sent by the team today",
      "toRewards": "Points & rewards",
      "toTeam": "Strengthen others",
      "toDecisions": "Conversations",
      "toPeople": "People & Roles",
      "toNotifications": "Notifications"
    },
    "content": {
      "title": "Content",
      "tabs": {
        "dailyWords": "Daily Word",
        "dailyPrayers": "Prayer of the Day",
        "oneThings": "One thing today",
        "paths": "Grow paths",
        "shots": "Hey Shots",
        "seasons": "Seasons",
        "challenges": "Challenges",
        "cohorts": "Waves"
      },
      "date": "Date",
      "locale": "Language",
      "verseRef": "Reference",
      "verseText": "Verse text",
      "impulse": "Impulse",
      "voice": "Voice (optional)",
      "prayerTitle": "Title",
      "prayerBody": "Prayer text (one paragraph per line)",
      "durationSec": "Duration (seconds)",
      "text": "Text",
      "empty": "No entry",
      "globalFallback": "Global (shown until you add your own)",
      "overlay": "Own entry – overrides global",
      "today": "Today",
      "window": "Window",
      "weeksAhead": "{n} weeks ahead",
      "slug": "Slug",
      "pathTitle": "Title",
      "description": "Description",
      "theme": "Colour",
      "customColor": "Custom colour",
      "hidePath": "Hide / Disable",
      "showPath": "Show / Enable",
      "pathHidden": "Hidden (Disabled)",
      "pathVisible": "Visible (Published)",
      "pathHiddenHint": "Learners cannot see or start this path in the app",
      "pathVisibleHint": "Visible to learners in the app",
      "pathDisabledToast": "Path hidden and disabled in the app",
      "pathEnabledToast": "Path is now visible in the app",
      "sessionPoints": "Points per session",
      "certificatePoints": "Points for certificate",
      "sessions": "{n} sessions",
      "openPath": "Open path",
      "newPath": "New path",
      "newSession": "New session",
      "newQuestion": "New question",
      "sessionTitle": "Title",
      "videoId": "YouTube link or video ID",
      "videoDuration": "Video length (seconds)",
      "youtubeFetch": "Fetch details",
      "youtubeFetching": "Fetching info …",
      "invalidYoutube": "Enter a YouTube link or an 11-character video ID.",
      "youtubeAutofilled": "Auto-filled from YouTube",
      "previewCard": "Card preview",
      "defaultReflection": "What is your main takeaway from this session for your everyday life?",
      "defaultStepCard": "Apply one insight in your life today.",
      "captions": "Captions available",
      "reflectionPrompt": "Reflection prompt",
      "stepCard": "Step card (optional)",
      "questions": "Questions",
      "prompt": "Question",
      "options": "Answers (one per line)",
      "correctIndex": "Correct answer (no.)",
      "explanation": "Explanation",
      "kind": "Type",
      "multipleChoice": "Multiple choice",
      "yesNo": "Yes/No",
      "free": "Free question",
      "noCorrectAnswer": "No correct answer (free question)",
      "optionsNeedTwo": "Add at least two answers, one per line.",
      "optionsOptional": "Optional for a free question. One answer per line.",
      "correctIndexRange": "The correct-answer number is higher than the number of answers.",
      "shotTitle": "Title",
      "newShot": "New shot",
      "seasonTitle": "Title",
      "subtitle": "Subtitle",
      "startsOn": "Starts on",
      "weeks": "Weeks",
      "active": "Active",
      "linkedPath": "Linked path",
      "noPath": "No path",
      "newSeason": "New season",
      "readOnlyGlobal": "Only the Hey Church team can change global content.",
      "noRows": "Nothing here yet.",
      "learners": "{n} learners",
      "certificates": "{n} certificates",
      "challengeTitle": "Challenge",
      "dailyPrompt": "Daily prompt",
      "durationDays": "Duration (days)",
      "lifeArea": "Life area",
      "dayPoints": "Points per day",
      "completionPoints": "Completion bonus",
      "newChallenge": "New challenge",
      "cohorts": "Waves",
      "participants": "Participants",
      "completions": "Completions",
      "totalOnCompletion": "{points} on completion",
      "cohortsTitle": "Waves",
      "cohortsBody": "Every start day forms a wave. Numbers refresh live.",
      "code": "Code",
      "start": "Start",
      "state": "State",
      "checkInsToday": "today",
      "messages": "messages",
      "noCohorts": "No waves yet.",
      "coverImage": "Cover image URL"
    },
    "questions": {
      "title": "Anonymous questions",
      "open": "Open",
      "answered": "Answered",
      "answer": "Answer",
      "send": "Send answer",
      "overdue": "Overdue",
      "none": "No questions in this list.",
      "session": "On session: {title}",
      "noSession": "General question",
      "asked": "Asked {when}",
      "answeredAt": "Answered {when}",
      "hint": "You never see who asked. The answer lands in that person's app."
    },
    "settings": {
      "title": "Settings",
      "church": "Church",
      "name": "Name",
      "timezone": "Time zone",
      "defaultLocale": "Default language",
      "celebration": "Celebration",
      "celebrationUrl": "YouTube link (latest service)",
      "celebrationTitle": "Title",
      "celebrationDate": "Date",
      "links": "Links",
      "teamUrl": "Team link (get involved)",
      "donateUrl": "Donate link",
      "churchCenterUrl": "Church Center link",
      "contacts": "Contacts",
      "crisisContact": "Crisis contact",
      "decisionContact": "Decision contact",
      "none": "— not set —",
      "staff": "Team",
      "inactive": "waiting for 2FA",
      "adminsOnly": "Only admins can change settings.",
      "preview": "Preview",
      "noChurch": "Pick a church above to see its settings.",
      "calendlyUrl": "Calendly link (Follow Jesus conversations)",
      "legal": "Legal pages (Hey Church)",
      "legalApp": "Legal pages (Hey Life app)",
      "legalAppBody": "All users see this under Me → App tab (Datenschutz, Impressum, AGB). Superadmin only.",
      "legalAppHint": "Same locale rules as other content (app language, then DE, then EN). Tap a page below to edit.",
      "legalFor": "Saved for: {church}",
      "legalBody": "Your church’s copy appears under Me → Hey Church tab. Same locale rules as other content (app language, then DE, then EN).",
      "legalLocaleHint": "German and English fields like Content — members see the version matching their app language.",
      "legalViewOnly": "Only church admins can edit legal text.",
      "globalScopeHint": "Global scope — edit Hey Life app legal pages below. Pick a church in the sidebar for church settings.",
      "legalToolbar": "Formatting",
      "legalAlignLeft": "Align left",
      "legalAlignCenter": "Align center",
      "legalAlignRight": "Align right",
      "legalForbiddenSuper": "App-wide legal pages can only be saved by a superadmin (e.g. superadmin@demo.heylife.test). To hide Datenschutz for your church only, use “Legal pages (Hey Church)” with that church selected in the sidebar.",
      "legalPlaceholder": "Write your legal text here…",
      "legalPrivacy": "Privacy (Datenschutz)",
      "legalImprint": "Imprint (Impressum)",
      "legalTerms": "Terms (AGB)",
      "legalEdit": "Edit",
      "legalEmpty": "No text yet — hidden in the app.",
      "legalLocaleDe": "German",
      "legalLocaleEn": "English",
      "legalPreview": "Preview",
      "audit": "Audit log",
      "auditBody": "Every send, role change, person, template, PDF and reward change — readable for pastors and admins.",
      "auditExport": "Export as Word",
      "auditEmpty": "No entries yet.",
      "sentryDevTitle": "Diagnostics",
      "sentryDevBody": "Send a test event to Sentry (non-production only).",
      "sentryTestMessage": "Test Sentry message",
      "sentryTestCrash": "Test Sentry crash",
      "sentryTestSent": "Test event sent to Sentry. Check Issues (environment: development) in about a minute.",
      "auditActor": "Admin",
      "auditAction": "Action",
      "auditTarget": "Target",
      "auditTime": "Time"
    },
    "churches": {
      "title": "Churches",
      "new": "New church",
      "name": "Name",
      "slug": "Slug",
      "adminEmail": "Admin e-mail (optional, receives invite)",
      "create": "Create",
      "status": "Status",
      "members": "Members",
      "admins": "Admins",
      "pendingInvites": "Pending invites",
      "invite": "Invite",
      "inviteEmail": "E-mail",
      "role": "Role",
      "goLiveMissing": "Missing for live: {items}",
      "crisis_contact": "crisis contact",
      "decision_contact": "decision contact",
      "invites": "Invites",
      "sent": "Invite sent.",
      "created": "Church created.",
      "statusChanged": "Status changed.",
      "expires": "expires {when}",
      "accepted": "accepted",
      "pending": "pending"
    },
    "features": {
      "title": "Feature matrix · {church}",
      "hint": "Control which Command Center modules, mobile navigation, and app capabilities are available for this church. Role defaults still apply for app features; you can only turn items off for the church. Logged-out guests use the guest tab settings at the top of this page.",
      "saved": "Feature matrix saved.",
      "guestTabs": {
        "title": "Logged-out and guest users",
        "hint": "Choose which mobile tabs logged-out guests and accounts with no church and no Fam see in the app.",
        "saved": "Guest tabs saved."
      },
      "adminSection": "Command Center",
      "contentSection": "Content tabs",
      "mobileTabsSection": "Mobile app · tabs",
      "mobileMeSection": "Mobile app · Me menu",
      "me": {
        "credentials": "Certificates",
        "points": "Points",
        "gym": "Hey Gym",
        "journal": "Journal",
        "prayFor": "Who I pray for",
        "fam": "Hey Fam",
        "myTeam": "My team",
        "followJesus": "Follow Jesus",
        "invest": "Invest",
        "talk": "Talk to someone",
        "care": "Care view",
        "myChurch": "My church"
      },
      "appSections": {
        "onboarding": "Onboarding & account",
        "home": "Home",
        "challenges": "Challenges",
        "community": "Community",
        "me": "Me",
        "leadership": "Leadership & care"
      },
      "app": {
        "guestMode": "Guest mode",
        "accountCreate": "Create account",
        "myChurch": "My church picker",
        "languageQuiet": "Language & quiet hours",
        "notifications": "Notifications",
        "dailyWord": "Daily Word",
        "celebration": "Last celebration",
        "activeQuest": "Active quest",
        "balanceRing": "Balance ring",
        "oneThingToday": "One thing today",
        "followUpPrompt": "Follow-up prompt",
        "challengesBrowse": "Discover waves",
        "challengeCheckIn": "Check-in",
        "cohortChat": "Cohort chat",
        "challengeShareCard": "Completion card",
        "stayTogetherFam": "Stay together → Fam",
        "feed": "Feed",
        "prayerWallRead": "Prayer wall (read)",
        "prayerShare": "Share prayer request",
        "prayerComments": "Prayer comments",
        "famChat": "Fam chat",
        "directMessages": "Direct messages",
        "famIdeas": "Fam ideas & polls",
        "certificates": "Certificates",
        "gym": "Hey Gym",
        "journal": "Journal",
        "heyFam": "Hey Fam",
        "myTeam": "My team",
        "prayFor": "Who I pray for",
        "invest": "Invest",
        "talkSomeone": "Talk to someone",
        "faithCheck": "Faith check",
        "careView": "Care view",
        "decisionsTake": "Take decisions",
        "leadFam": "Lead Fam",
        "commandCenter": "Command Center (app)"
      }
    },
    "activate": {
      "title": "Activate your access",
      "body": "Confirm to turn on your Command Center access.",
      "start": "Activate",
      "scan": "Scan the QR code with your authenticator app, then enter the 6-digit code.",
      "manual": "Or enter manually:",
      "code": "Code",
      "verify": "Verify & activate",
      "backupCodes": "Backup codes – keep them safe:",
      "done": "Done. Your access is active."
    },
    "attention": {
      "title": "Needs Attention",
      "body": "One queue. Each item has a severity, an SLA and one primary action.",
      "empty": "Nothing needs attention. Enjoy the quiet.",
      "refresh": "Re-evaluate",
      "resolve": "Mark done",
      "overdue": "overdue",
      "dueIn": "due {time}",
      "since": "since {time}",
      "critical": "Critical",
      "high": "High",
      "medium": "Medium",
      "kind": {
        "crisis_flag": "Crisis flag",
        "decision_uncontacted": "Decision awaiting contact",
        "unprayed_urgent": "Unprayed urgent request",
        "unanswered_question": "Unanswered question",
        "moderation_report": "Moderation queue",
        "care_open": "Care request",
        "role_approval": "Role approval",
        "fam_request": "Fam request",
        "church_go_live": "Go-live blocked",
        "reward_request": "Reward request",
        "baptism_call": "Call personally",
        "backup_stale": "Backup stale"
      },
      "action": {
        "care": "Open care",
        "questions": "Answer",
        "moderation": "Review",
        "people": "Approve",
        "fams": "Open Fams",
        "prayer": "Open wall",
        "churches": "Open church",
        "rewards": "Open rewards",
        "decisions": "Open conversation",
        "ops": "Open status page"
      },
      "takeCare": "Take over",
      "closeCare": "Close"
    },
    "moderation": {
      "title": "Moderation",
      "body": "Reported content from chat, feed, prayer wall and check-ins. Reported items are already hidden for the reporter.",
      "open": "Open",
      "decided": "Decided",
      "empty": "No open reports.",
      "reportedBy": "reported by {name}",
      "author": "by {name}",
      "prior": "{count} earlier reports",
      "hide": "Hide",
      "remove": "Remove",
      "dismiss": "Dismiss",
      "hideHint": "Hidden: the author still sees it.",
      "removeHint": "Removed: gone for everyone.",
      "status": {
        "open": "open",
        "hidden": "hidden",
        "removed": "removed",
        "dismissed": "dismissed"
      },
      "type": {
        "message": "Chat message",
        "feed_post": "Feed post",
        "prayer_request": "Prayer request",
        "check_in": "Check-in"
      }
    },
    "prayerWall": {
      "title": "Prayer wall",
      "body": "Every request your church can see, including Fam-only ones in their 2-hour window.",
      "withdraw": "Withdraw",
      "withdrawn": "withdrawn",
      "answered": "answered",
      "crisis": "crisis flag",
      "prayers": "{count} prayed",
      "famWindow": "Fam only",
      "empty": "No requests."
    },
    "fams": {
      "title": "Fams",
      "body": "Liveness per Fam, open requests and the Planning Center connection.",
      "members": "{total} members · {inFam} in a Fam · {requested} requested",
      "requests": "Open requests",
      "requestsEmpty": "No open requests.",
      "confirm": "Confirm",
      "decline": "Decline",
      "matching": "Get-matched requests",
      "matchingEmpty": "No one waiting to be matched.",
      "place": "Place in Fam",
      "dismiss": "Dismiss",
      "prefs": "Wishes",
      "list": "All Fams",
      "new": "New Fam",
      "edit": "Edit Fam",
      "name": "Name",
      "description": "Description",
      "capacity": "Capacity",
      "leader": "Leader (user id)",
      "leaderHint": "Pick from People & Roles; empty = no leader yet.",
      "meetingDay": "Day",
      "meetingTime": "Time",
      "area": "Area",
      "churchCenterUrl": "Church Center link",
      "headerImage": "Header image URL",
      "baptism": "Baptism Fam",
      "archived": "Archived",
      "origin": {
        "pco": "Planning Center",
        "manual": "Manual",
        "global": "Global"
      },
      "liveness": {
        "green": "alive",
        "yellow": "quiet",
        "red": "silent",
        "archived": "archived",
        "grey": "no chat yet"
      },
      "colMembers": "Members",
      "colRequests": "Requests",
      "colChat": "Chat (7 d)",
      "colLast": "Last message",
      "colLeader": "Leader",
      "never": "never",
      "pcoTitle": "Planning Center Groups",
      "pcoConnected": "Connected · last sync {when}",
      "pcoNever": "Connected · not synced yet",
      "pcoError": "Last sync failed: {error}",
      "pcoNot": "Not connected — the Fam list is maintained here by hand.",
      "pcoAppId": "Application ID",
      "pcoSecret": "Secret",
      "pcoConnect": "Connect",
      "pcoDisconnect": "Disconnect",
      "pcoSync": "Sync now",
      "pcoSynced": "Synced: {groups} groups, {created} new, {confirmed} requests confirmed.",
      "pcoHint": "Personal Access Token from api.planningcenteronline.com. Read-only; stored encrypted. Use \"demo\" as both values on the testing server.",
      "pcoReadonly": "Managed in Planning Center — name, schedule and image sync automatically.",
      "noChurch": "Pick a church to manage Fams."
    },
    "pulse": {
      "title": "Pulse",
      "body": "Last 7 days against the 7 before. Numbers come from the nightly fact table — counts only, never content.",
      "empty": "No facts yet. The nightly job fills this table after the first night.",
      "wow": "vs. previous week",
      "chart": "Last {days} days",
      "latest": "Snapshot {day}",
      "wau": "Weekly active",
      "members": "Accounts",
      "guests": "Guests",
      "famMembers": "In a Fam",
      "balanced": "Balanced share",
      "balancedHint": "People active in at least three areas this week.",
      "metric": {
        "dau": "Daily active (avg)",
        "new_users": "New people",
        "check_ins": "Check-ins",
        "prayers": "Prayers of the Day",
        "prayer_requests": "Prayer requests",
        "messages": "Chat messages",
        "sessions_completed": "Sessions completed",
        "gym_sessions": "Gym units",
        "journal_entries": "Journal entries",
        "fam_requests": "Fam requests",
        "points_awarded": "Points awarded",
        "notifications_opened": "Pushes opened"
      },
      "series": {
        "dau": "Daily active",
        "check_ins": "Check-ins",
        "prayers": "Prayers",
        "messages": "Messages",
        "sessions_completed": "Sessions"
      }
    },
    "people": {
      "title": "People & Roles",
      "kicker": "PEOPLE · {n} of {m}",
      "search": "Search name, alias, email, postcode, address",
      "allRoles": "All roles",
      "add": "Add person",
      "edit": "Edit",
      "save": "Save",
      "cancel": "Cancel",
      "deletePerson": "Delete person",
      "deleteHint": "Data is permanently removed after 30 days.",
      "deleted": "Deletion scheduled.",
      "filterFam": "In a Fam",
      "filterTeam": "In a team",
      "filterBaptized": "Baptised",
      "filterChildren": "With children",
      "col": {
        "fullName": "Full name",
        "alias": "Alias",
        "email": "Email",
        "phone": "Phone",
        "sex": "Sex",
        "birthday": "Birthday → age",
        "address": "Address",
        "postcode": "Postcode",
        "fam": "Fam",
        "team": "Team",
        "baptism": "Baptism",
        "marital": "Marital status",
        "children": "Children",
        "childrenAges": "Children's ages",
        "role": "Role",
        "points": "Points"
      },
      "years": "{n} y",
      "months": "{n} mo",
      "yes": "Yes",
      "no": "No",
      "childrenYes": "Yes · {n}",
      "unknown": "—",
      "marital": {
        "single": "single",
        "married": "married",
        "divorced": "divorced"
      },
      "role": {
        "member": "Member",
        "leader": "Leader",
        "pastor": "Pastor",
        "admin": "Admin"
      },
      "approvals": "Four-eyes approvals",
      "approvalsEmpty": "Nothing to approve.",
      "approvalRow": "{name} → {role} · proposed by {by}",
      "approve": "Approve",
      "reject": "Reject",
      "ownProposal": "Your own proposal — a colleague approves.",
      "pending": "Approval pending",
      "proposed": "Proposed — a second admin approves.",
      "roleChanged": "Role changed.",
      "childrenBirthdays": "Children's birth dates",
      "addChild": "Add child",
      "remove": "Remove",
      "required": "Full name and email are required.",
      "adminsOnly": "Only admins change roles and add or delete people.",
      "empty": "Nobody matches.",
      "fullNamePrivacy": "Full name and address are visible to pastors and admins only; the app shows the alias.",
      "message": "Message",
      "created": "Person added.",
      "saved": "Saved."
    },
    "notifications": {
      "title": "Notifications",
      "body": "Write a message and send it as a push, an email, or both. Church admins send inside their church. A super admin also chooses every church or one person.",
      "send": "Send message",
      "templates": "Templates",
      "newTemplate": "New template",
      "filter": "Filter templates",
      "audience": "Audience",
      "medium": "Medium",
      "reachChurch": "This church",
      "reachEveryone": "Every church",
      "reachPerson": "One person",
      "pickChurch": "Choose a church",
      "personSearch": "Name or email",
      "to": "To {name}",
      "titleLabel": "Title",
      "textLabel": "Text",
      "localizedRequired": "Enter a title and text in German and/or English.",
      "preview": {
        "push": "Push preview",
        "email": "Email preview",
        "both": "Push and email"
      },
      "sendTo": "Send to {n}",
      "sendOne": "Send",
      "testToMe": "Test message to me",
      "testSent": "Test message queued ({status}).",
      "sent": "Sent to {n}.",
      "scheduled": "Scheduled.",
      "schedule": "Schedule (optional)",
      "usingTemplate": "Using template “{name}” — everything stays editable.",
      "placeholders": "Placeholders: {FirstName} {Fam} {Challenge} {Team} {VIP}",
      "name": "Name",
      "dimension": "Dimension",
      "category": "Category",
      "audienceDefault": "Default audience",
      "buttons": "Buttons in the message",
      "buttonLabel": "Label",
      "buttonRoute": "Route",
      "addButton": "Add button",
      "system": "System",
      "custom": "Custom",
      "deleteTemplate": "Delete template",
      "sendWith": "Send with this template",
      "log": "Sent",
      "logEmpty": "Nothing sent yet.",
      "today": "Today: {sent} sent · {queued} queued · {skipped} skipped · {opened} opened",
      "recipients": "{n} recipients",
      "scheduledFor": "scheduled {date}",
      "by": "by {name}",
      "close": "Close",
      "aud": {
        "all": "All",
        "guest": "Guest",
        "global": "Global",
        "hey_church": "Hey Church",
        "leader": "Leader",
        "pastor_admin": "Pastor/Admin",
        "user": "Person"
      },
      "via": {
        "push": "Push",
        "email": "Email",
        "both": "Push and email"
      },
      "cat": {
        "rhythm": "Rhythm",
        "fam_cohort": "Fam & challenge",
        "progress": "Progress",
        "personal": "Personal",
        "staff": "Staff"
      },
      "tabTemplates": "Templates",
      "tabMatrix": "Notification matrix",
      "tabOthers": "Others",
      "automatic": {
        "title": "Automatic notifications",
        "hint": "Choose Email, Push, and Logged out for each automatic action in this church. Fixed rows stay email-only. Logged out is saved only — delivery comes later.",
        "saved": "Automatic notification settings saved.",
        "fixedEmail": "Fixed — email only",
        "inAppDefault": "In the app by default",
        "othersTitle": "Others — Custom notifications",
        "othersHint": "Create announcements that are not part of the predefined automatic notification list.",
        "othersCreate": "+ Create custom notification",
        "othersCreateTitle": "Create custom notification",
        "othersCreateHint": "For one-off news like a cancelled prayer meeting or a new location. Members see it in the Community feed when enabled, and can get push or email. Guests of this church receive it too.",
        "othersPublishFeed": "Publish to Community feed",
        "othersFeedPublished": "Published to Community feed",
        "othersAudience": "{n, plural, =0 {Sends to Hey Church members in this church (no recipients yet).} one {Sends to Hey Church members in this church (# person).} other {Sends to Hey Church members in this church (# people).}}",
        "othersSend": "Publish announcement",
        "othersCreated": "Announcement published.",
        "othersSoon": "Coming in a later release",
        "columns": {
          "action": "Automatic action",
          "email": "Email",
          "push": "Push",
          "loggedOut": "Logged out"
        }
      },
      "groups": {
        "home": "Home",
        "grow": "Grow",
        "challenges": "Challenges",
        "community": "Community",
        "me": "Me",
        "signIn": "Sign in",
        "commandCenter": "Command Center"
      },
      "subsections": {
        "session": "Session",
        "myQuestions": "My questions",
        "cohort": "Cohort",
        "cohortChat": "Cohort chat",
        "prayer": "Prayer",
        "fam": "Fam",
        "talkRequest": "Talk request",
        "followJesus": "Follow Jesus",
        "myTeam": "My team",
        "points": "Points",
        "credentials": "Credentials",
        "gym": "Hey Gym",
        "settings": "Settings",
        "care": "Care",
        "today": "Today",
        "questions": "Questions",
        "fams": "Fams",
        "people": "People",
        "rewards": "Rewards"
      },
      "actions": {
        "home_dailyWord": "Daily Word at 08:00 (skipped if the app was opened today)",
        "home_growSheet": "Grow sheet once per cold start when questions are still open",
        "home_celebrationReminder": "Celebration service reminder (e.g. Sunday morning)",
        "home_activeQuestReminder": "Active quest still in progress — gentle nudge",
        "grow_quizContinue": "15 minutes after the last answer — continue your quiz (once per session)",
        "grow_session_questionsWaiting": "Your questions are waiting (in-app prompt)",
        "grow_session_videoIncomplete": "Session video started but not finished",
        "grow_session_reflectionDue": "Session reflection not submitted yet",
        "grow_myQuestions_answered": "Your anonymous question was answered",
        "challenges_cohort_checkInOpen": "19:00 — today's check-in is still open",
        "challenges_cohort_completedShare": "Challenge completed — share card ready (if not in app)",
        "challenges_cohort_stayTogetherFam": "Wednesday stay together as a Fam? (after cohort ends)",
        "challenges_cohort_invitePending": "Challenge cohort invite waiting for your response",
        "challenges_cohort_checkInMissed": "You missed yesterday's cohort check-in",
        "challenges_cohortChat_newMessages": "New messages in cohort chat (collapsed, daily cap)",
        "community_prayer_newRequest": "New prayer request routed to your Fam",
        "community_prayer_prayedForYou": "Someone prayed for your request (once per day)",
        "community_prayer_markedAnswered": "Your prayer request was marked answered on the wall",
        "community_fam_placement": "Fam request confirmed or church placed you in a Fam",
        "community_fam_newMessages": "New messages in Fam chat (collapsed, daily cap)",
        "community_fam_newMember": "Someone new joined your Hey Fam",
        "me_talkRequest_pastorAssigned": "Someone will reach out — pastor took your talk request",
        "me_talkRequest_received": "We received your talk to someone request (confirmation)",
        "me_talkRequest_followUp48h": "Talk request update if no outreach within 48 hours",
        "me_followJesus_youSaidYes": "You said yes (once)",
        "me_followJesus_bookSlot": "Two days later — book a slot",
        "me_followJesus_baptismFam": "Baptism Fam invite and follow-ups",
        "me_followJesus_conversationPdf": "Conversation PDF when an admin sends it",
        "me_myTeam_checkInCard": "Four-week check-in card",
        "me_myTeam_checkInReminder": "Check-in on day 28 and 56 if card not answered",
        "me_myTeam_leaderAssigned": "Your My Team link or leader was assigned",
        "me_points_rewardReady": "Reward ready to redeem (once per reward)",
        "me_points_rewardUpdate": "Leader set a date or reward was sent",
        "me_points_streakMilestone": "Points milestone reached (before a reward unlock)",
        "me_points_thirtyDaysWithGod": "30 Days with God (within five minutes, resendable)",
        "me_credentials_certificateReady": "Grow or Hey Gym certificate ready (if not on screen)",
        "me_gym_planReminder": "Next evening — your Gym plan is one step away",
        "me_gym_weeklyProgress": "Weekly Hey Gym progress nudge",
        "me_settings_deletionConfirm": "Deletion confirmation with date and how to cancel",
        "me_care_crisis": "Crisis wording — immediate (ignores quiet hours and cap)",
        "me_care_sameDayCare": "Same day — talk request, urgent prayer, someone said yes",
        "me_care_pastorEmailFallback": "Same three when pastor has no push token",
        "me_journal_eveningPrompt": "Evening journal prompt (in-app)",
        "signIn_magicLink": "Magic link",
        "commandCenter_today_weeklyDigest": "Monday 07:00 — weekly numbers and needs attention",
        "commandCenter_questions_open48h": "Once a day — anonymous questions open after 48 hours",
        "commandCenter_fams_joinOrMatch": "Someone asked to join a Fam or to be matched",
        "commandCenter_people_fourEyesApproval": "Four-eyes role approval waiting",
        "commandCenter_people_adminInvite": "Admin invite and role grant",
        "commandCenter_rewards_redeemLeader": "Reward redemption needs a leader"
      }
    },
    "rewards": {
      "title": "Points & rewards",
      "body": "Point values apply at once to new actions; old entries keep theirs. Rewards are milestones with a threshold.",
      "points": "Point values",
      "action": "Action",
      "defaultValue": "Default",
      "value": "{scope} value",
      "dailyLimit": "Daily limit",
      "unlimited": "unlimited",
      "override": "Church override",
      "global": "Global defaults",
      "saveConfig": "Save values",
      "saved": "Saved.",
      "rewardsList": "Rewards",
      "newReward": "New reward",
      "editReward": "Edit reward",
      "threshold": "Threshold",
      "kind": "Type",
      "leaders": "Leaders (one per line)",
      "fileUrl": "File link (digital book)",
      "active": "Active",
      "inactive": "Inactive",
      "requests": "Redemptions",
      "requestsEmpty": "No redemptions yet.",
      "dateSet": "Mark “date set”",
      "markSent": "Mark sent",
      "resend": "Resend email",
      "status": {
        "redeemable": "redeemable",
        "requested": "requested",
        "date_set": "date set",
        "sent": "sent"
      },
      "kinds": {
        "physical": "Physical",
        "digital_book": "Digital book",
        "leader_meet": "Leader meeting"
      },
      "prefers": "prefers {leader}",
      "noPhone": "no phone",
      "call": "Call",
      "actions": {
        "prayer_of_day": "Prayer of the Day",
        "prayer_request": "Prayer request",
        "intercession": "Intercession (card shared)",
        "prayed_for": "Prayed for a request",
        "invitation": "Invitation (sign-up)",
        "challenge_day": "Challenge · per day",
        "challenge_complete": "Challenge · completion",
        "session_engaged": "Grow · per session",
        "path_certificate": "Grow · certificate",
        "gym_session": "Hey Gym · per session",
        "gym_plan_complete": "Hey Gym · plan completed",
        "one_thing": "One thing today",
        "journal_entry": "Journal entry",
        "feed_post": "Feed post",
        "check_in": "Check-in"
      }
    },
    "team": {
      "title": "Strengthen others",
      "body": "Who looked at the teams, what they answered, who needs a follow-up.",
      "filter": {
        "all": "All",
        "trying": "Trying it out",
        "arrived": "Arrived",
        "no_contact": "No contact yet",
        "not_interested": "Not interested",
        "none": "No answer yet"
      },
      "col": {
        "name": "Name",
        "clicked": "Link clicked",
        "answer": "Answer",
        "next": "Next check-in",
        "actions": "Actions"
      },
      "ask": "Ask",
      "asked": "Check-in pushed.",
      "message": "Message",
      "empty": "Nobody is at this point right now.",
      "followUp": "Follow up",
      "followUpBody": "No answer 4 weeks after the check-in, or “not interested right now”.",
      "reasonNoAnswer": "No answer · check-in {n} days ago",
      "reasonNotInterested": "Not interested · {choice}",
      "choice": {
        "have_team": "already has a team",
        "unsure": "unsure which team fits",
        "none": "no reason given"
      },
      "due": "due",
      "noUrl": "Set the team link under Settings first.",
      "kpiClicked": "Looked at the teams",
      "kpiArrived": "Arrived in a team",
      "kpiFollowUp": "Need a follow-up"
    },
    "decisions": {
      "title": "Follow Jesus · Conversations",
      "body": "Everyone who said yes: phone, slot, status, notes and traffic light. Notes never reach the app.",
      "col": {
        "name": "Name",
        "phone": "Phone",
        "slot": "Slot",
        "status": "Status",
        "light": "Traffic light",
        "baptism": "Baptism Hey Fam"
      },
      "call": "Call",
      "open": "open",
      "held": "held",
      "light": {
        "none": "not set",
        "green": "green · invite to Baptism Hey Fam",
        "yellow": "yellow · needs something else",
        "grey": "grey · not a topic right now"
      },
      "notes": "Notes (pastor/admin only)",
      "saveNotes": "Save notes",
      "saved": "Saved.",
      "slotManual": "Slot (manual)",
      "viaCalendly": "via Calendly",
      "noSlot": "no slot yet",
      "sendPdf": "Send PDF",
      "pdfSent": "PDF sent",
      "pdfMeta": "{email} (Calendly)",
      "pdfNoEmail": "no email from Calendly",
      "pdfNeedsHeld": "available once the conversation is held",
      "pdfCard": "PDF after the conversation",
      "pdfUpload": "Upload another PDF",
      "pdfNone": "No PDF yet.",
      "pdfInfo": "{date} · {size} · {pages} pages",
      "pdfTooBig": "PDF must be 10 MB or less.",
      "pdfUploaded": "PDF replaced for all future sends.",
      "baptismInvited": "invited {date}",
      "baptismReminders": "{n} reminders",
      "baptismSignedUp": "signed up {date}",
      "callTask": "Call personally",
      "callDone": "Called",
      "empty": "Nobody has said yes yet.",
      "yesMail": "“You said yes” mail sent",
      "noCalendly": "Set the Calendly link under Settings so people can book."
    },
    "theme": {
      "dark": "Dark theme",
      "light": "Light theme"
    }
  },
  "card": {
    "prayerFor": "Prayer for {name}",
    "pathCertificate": "Certificate · Grow",
    "gymCertificate": "Certificate · Hey Gym",
    "completedBy": "This certifies that",
    "completedWhat": "has completed",
    "challengeDone": "Challenge completed",
    "checkIns": "{count} of {total} check-ins",
    "joinMe": "Join me — the link starts you on my day:"
  },
  "push": {
    "dailyWordTitle": "Your word for today",
    "dailyWordBody": "{ref} — one minute for you.",
    "checkinTitle": "Still open: today's check-in",
    "checkinBody": "{title} · day {day}. Tap to check in.",
    "careNewTitle": "Someone wants to talk",
    "careNewBody": "A new request is waiting in Care.",
    "careTakenTitle": "Someone will reach out",
    "careTakenBody": "A member of the pastoral team has taken your request.",
    "challengeDoneTitle": "Challenge completed",
    "challengeDoneBody": "{title} — your card is ready to share.",
    "crisisTitle": "Urgent: a message needs your attention",
    "crisisBody": "Crisis wording was detected. Open Care now.",
    "urgentTitle": "Urgent prayer request",
    "famRequestTitle": "New prayer request in your Fam",
    "prayedTitle": "Someone prayed for you",
    "prayedBody": "{count, plural, one {# person prayed} other {# people prayed}} for your request.",
    "certificateTitle": "Certificate earned",
    "certificateBody": "{title} is in your credentials.",
    "famRequestedTitle": "New Fam request",
    "famRequestedBody": "{alias} asked to join {fam}.",
    "matchTitle": "Someone wants to be matched",
    "matchBody": "{alias} is looking for a Hey Fam.",
    "famConfirmedTitle": "You are in",
    "famConfirmedBody": "Welcome to {fam}. The Fam chat is open for you now.",
    "matchedBody": "Your church placed you in {fam}. Say hi in the chat.",
    "rewardTitle": "A reward is waiting",
    "rewardBody": "You reached {reward}. Redeem it in the Me tab.",
    "rewardRequestTitle": "Reward request",
    "rewardRequestBody": "{alias} wants to redeem {reward}.",
    "rewardDateTitle": "Date set",
    "rewardDateBody": "{leader} will get in touch about your {reward}.",
    "rewardSentTitle": "On its way",
    "rewardSentBody": "Your {reward} has been sent.",
    "decisionTitle": "Someone said yes",
    "decisionBody": "{alias} wants to follow Jesus. Reach out.",
    "bookTalkTitle": "Let's talk",
    "bookTalkBody": "You said yes — book a slot or ask us to call you.",
    "baptismInviteTitle": "Baptism Hey Fam",
    "baptismInviteBody": "You are invited to the Baptism Hey Fam. Sign up this week.",
    "baptismRemindTitle": "Signed up yet?",
    "baptismRemindBody": "Have you signed up for the Baptism Hey Fam? Tap to answer.",
    "teamCheckinTitle": "Four weeks later",
    "teamCheckinBody": "You looked at the teams. Where are you now?",
    "approvalTitle": "Role approval needed",
    "approvalBody": "A colleague proposed the {role} role. Four eyes, please.",
    "quizContinueTitle": "Continue with your quiz",
    "quizContinueBody": "{title} still has open questions."
  }
}
